<template>
  <div>

    <!--    this section comment because  we have header action in vs-table header -->

    <!--<div class="row">
      <div class="col-6 d-flex align-items-end justify-content-end">
        <button v-b-modal.add-person class="btn iconed btn-secondary"><i class="icon-bd-plus"></i><span>جدید</span>
        </button>
      </div>
    </div>-->

    <vs-table v-if="show" :params="params" :options="options"></vs-table>

<!--    this section comment because  we have header action in vs-table header -->

    <!--<b-modal
      ref="modal"
      id="add-person"
      size="xl"
      title="افزودن کاربر"
      ok-title="ذخیره"
      cancel-title="لغو"
      @ok="createNewUser"
      @cancel="hideModal"
    >
      <add-person ref="addPerson" @add-person="userValues"></add-person>
    </b-modal>-->

  </div>
</template>

<script>
    import VsTable from "../_framework/VsTable.vue";
    import BaseService from "../_framework/api/BaseService.js";
    import userRoles from "../components/userRoles.vue";
    import Utils from "../_framework/utils/Utils.js";
    import AddPerson from "../components/AddPerson";
    import axios from "axios";

    export default {
        name: "users",
        components: {
            VsTable,
            AddPerson
        },
        data() {
            return {
                createUserModel: {},
                show: true,
                access: {},
                params: {
                    entity: "users",
                    list: [],
                    headers: {
                        firstName: {
                            title: "نام",
                            type: "text",
                            rowAlignment: "center"
                        },
                        lastName: {
                            title: "نام خانوادگی",
                            type: "text",
                            rowAlignment: "center"
                        },
                        userName: {
                            title: "نام کاربری",
                            type: "text",
                            rowAlignment: "center"
                        },
                        passWord: {
                            title: "رمز عبور",
                            type: "text",
                            rowAlignment: "center"
                        },
                        roles: {
                            title: "سمت ها",
                            type: "custom",
                            component: userRoles,
                            rowAlignment: "center"
                        }
                    }
                },
                options: {
                    dataSourceType: "api",
                    hasActions: true,
                    hasActionsInHeader: true,
                    beforeCreateEntity: input => {
                        // console.log(input);
                        this.refreshTable();
                        if (!input.roles) {
                            Utils.handleErrorWithNotification(
                                "انتخاب حداقل یک سمت الزامی است",
                                this.$noty
                            );
                            return null;
                        }
                        input["posts"] = input.roles.map(r => ({

                            postId: r.post.id,
                            companyId: r.company ? r.company.id : null,
                            outSourceId: r.outSource ? r.outSource.id : null
                        }));
                        return input;
                    },
                    beforeUpdateEntity: input => {
                        // console.log(input)
                        this.refreshTable();
                        if (!input.roles) {
                            Utils.handleErrorWithNotification(
                                "انتخاب حداقل یک سمت الزامی است",
                                this.$noty
                            );
                            return null;
                        }
                        input["posts"] = input.roles.map(r => ({
                            postId: r.post.id,
                            companyId: r.company ? r.company.id : null,
                            outSourceId: r.outSource ? r.outSource.id : null
                        }));
                        // console.log(input)
                        return input;
                    },
                    getTopRightButtons: () => {
                        let arr = [];
                        let searchToggleButton = {
                            component: "search-toggle-button"
                        };
                        arr.push(searchToggleButton);
                        return arr;
                    },
                    getTopLeftButtons: () => {
                        let arr = [];
                        let self = this;
                        let addItemButton = {
                            component: "toggle-table-actions-button",
                            params: {
                                onClick() {
                                    self.options.hasActions = !self.options.hasActions;
                                }
                            }
                        };
                        arr.push(addItemButton);
                        return arr;
                    }
                }
            };
        },
        mounted() {
            this.getAllUsers();
            this.refreshTable()
        },
        methods: {
            refreshTable() {
                /*this.show = false;
                setTimeout(() => {
                    this.show = true;
                }, 50);*/
                // this.$refs.table.onFetchEntityList();
            },
           /* createNewUser() {
                this.$store.commit("REMOVE_ALL_ROWS_FROM_VS_TABLE_FEED");
                new BaseService('Users').create(this.createUserModel).then((response) => {
                    // console.log(response.data);
                    this.$noty.success('کاربر با موفقیت افزوده شد');
                    this.$refs.addPerson.readable = false;
                    this.$refs.addPerson.userModel = {};
                    this.$refs.addPerson.posts = [];
                    this.$refs.addPerson.firstName = null;
                    this.$refs.addPerson.lastName = null;
                    this.$refs.addPerson.userName = null;
                    this.$refs.addPerson.password = null;

                    this.getAllUsers();
                    this.createUserModel = {};
                }).catch((error) => {
                    console.log(error)
                })
            },*/
            getAllUsers() {
                axios.get('Users').then((response) => {

                    // console.log(response.data)
                    this.refreshTable();
                }).catch((error) => {
                    console.log(error)
                })
            },
            hideModal() {
                this.$refs.modal.hide();
            },
            userValues(val) {
                // console.log(val)
                this.createUserModel = val;
            }


        },
        beforeMount() {
            this.options.access = checkAccess(this.$route.path);
            this.show = !!this.options.access;
        }
    };
</script>
